import type { ChatRoomListItem } from "@/features/chat/components/ChatRoomListSection";
import type {
  ChatRoomResponse,
  ExistingChatSummary,
} from "@/lib/humhub-api/types";

type ChatRoomListSource = ChatRoomResponse | ExistingChatSummary;

type ChatRoomListOptions = {
  useTitle?: boolean;
};

export const getChatRoomDisplayTitle = (
  room: ChatRoomListSource,
  options?: ChatRoomListOptions,
) =>
  options?.useTitle
    ? room.title
    : "display_title" in room && room.display_title
      ? room.display_title
      : room.title;

export const toChatRoomListItem = (
  room: ChatRoomListSource,
  options?: ChatRoomListOptions,
): ChatRoomListItem => ({
  id: room.id,
  title: room.title,
  displayTitle: getChatRoomDisplayTitle(room, options),
  imageUrl: "image_url" in room ? room.image_url : undefined,
  lastEntryContent:
    "last_entry_content" in room ? room.last_entry_content : undefined,
  hidden: "hidden" in room ? Boolean(room.hidden) : undefined,
});

export const mapChatRoomsToListItems = (
  rooms: ChatRoomListSource[],
  options?: ChatRoomListOptions,
) => rooms.map((room) => toChatRoomListItem(room, options));
